import { Menu, MenuItem, SubMenu } from '@/components/atoms';
import { Space } from 'antd';
import { Link } from 'react-router-dom';

type AdminMenuProps = {
  path: string;
};

const AdminMenu = ({ path }: AdminMenuProps) => {
  const [root, first] = path.split('/');
  return (
    <Menu mode="inline" defaultOpenKeys={[`/${first}`]} defaultSelectedKeys={[path]}>
      <SubMenu key="/admin" title={<Space direction="horizontal">Admin</Space>}>
        <MenuItem key="/admin/company">
          <Link to="/admin/company">Company List</Link>
        </MenuItem>
      </SubMenu>
    </Menu>
  );
};

export default AdminMenu;
